import { render, staticRenderFns } from "./footerInfo.vue?vue&type=template&id=295560dd&scoped=true&"
import script from "./footerInfo.vue?vue&type=script&lang=js&"
export * from "./footerInfo.vue?vue&type=script&lang=js&"
import style0 from "./footerInfo.vue?vue&type=style&index=0&id=295560dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295560dd",
  null
  
)

export default component.exports